import { useLang } from "../contexts/LangContext";
import useSEO from "../lib/useSEO";

const items = [
  { src: "/gallery/g6.png", alt: "Unser abendliches Catering-Setup mit Pavillon, Lichterketten und Servierstationen", shape: "blob-organic", span: "md:col-span-12", ratio: "aspect-[16/10]" },
  { src: "/gallery/g1.png", alt: "Tæste Pavillon-Setup mit Pizzaofen und Servierstation", shape: "blob-organic-2", span: "md:col-span-8", ratio: "aspect-[4/3]" },
  { src: "/gallery/g2.jpeg", alt: "Die Bunte, unsere vegane Pizza mit mediterranem Grillgemüse", shape: "blob-organic", span: "md:col-span-4", ratio: "aspect-[3/4]" },
  { src: "/gallery/g5.jpeg", alt: "Servierlinie mit frisch gebackenen Pizzen unter Wärmelampen", shape: "blob-organic-2", span: "md:col-span-6", ratio: "aspect-[4/3]" },
  { src: "/gallery/g4.png", alt: "Fertigstellung einer Pizza mit Pistaziencreme und Mortadella", shape: "blob-organic", span: "md:col-span-6", ratio: "aspect-[4/3]" },
  { src: "/gallery/g7.png", alt: "Mediterrane Vorspeisen, Antipasti und Wurst-Käse-Auswahl auf dem Buffet", shape: "blob-organic-2", span: "md:col-span-7", ratio: "aspect-[4/3]" },
  { src: "/gallery/g8.png", alt: "Hausgemachte Dips: Aioli-Creme, Chili-Flocken und Pesto", shape: "blob-organic", span: "md:col-span-5", ratio: "aspect-[3/4]" },
  { src: "/gallery/g9.png", alt: "Dessert-Tisch mit Dessertpizza und hausgemachtem Tiramisu", shape: "blob-organic-2", span: "md:col-span-6", ratio: "aspect-[4/3]" },
  { src: "/gallery/g10.png", alt: "Hausgemachtes Tiramisu mit æ-Signatur", shape: "blob-organic", span: "md:col-span-6", ratio: "aspect-[4/3]" },
];

export default function Gallery() {
  const { t } = useLang();
  useSEO({
    title: "Galerie — Impressionen unseres Pizza Catering | Tæste",
    description:
      "Einblicke in unser mobiles Pizza Catering aus Lohsa: Pavillon-Setup, handgemachte Pizza aus dem mobilen Pizzaofen, Antipasti-Buffet und hausgemachte Desserts für Events in der Lausitz.",
    keywords:
      "Tæste Galerie, Pizza Catering Hoyerswerda Bilder, mobiler Pizzaofen Catering, Catering Lausitz, Catering Lohsa",
    path: "/galerie",
  });
  return (
    <div data-testid="gallery-page" className="relative overflow-hidden">
      <div className="relative max-w-[1300px] mx-auto px-6 lg:px-12 py-20 md:py-28">
        <div className="max-w-2xl mb-16">
          <p className="eyebrow">{t.gallery.eyebrow}</p>
          <h1 className="font-display text-5xl md:text-7xl mt-3">{t.gallery.title}</h1>
          <p className="mt-6 text-[hsl(var(--muted-foreground))]">{t.gallery.body}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          {items.map((it, i) => (
            <figure
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`${it.span} ${it.ratio} overflow-hidden bg-[hsl(var(--secondary))] ${it.shape}`}
            >
              <img
                src={it.src}
                alt={it.alt}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </figure>
          ))}
        </div>
      </div>
    </div>
  );
}
